import {
  getListItemNodesQueryKey,
  JobStatusActionEnum,
} from "@/services/internalApiV1";
import { type ActionCableJobStatusData } from "@/types";

// Subscribes to job status updates and, on each completed to-teach worksheet
// import, fires a success flash and refreshes any open Meine Ablage / folders
// listings so the imported worksheet appears without a manual reload.
//
// The handler is gated on the JobStatusActionEnum action, so users without the
// to-teach feature flag pay no cost — those jobs never run for them.
//
// Deliberately not on useJobBroadcast: there is no waiting state here to bound.
// This listens app-wide for imports started anywhere, flashes and refreshes —
// nothing spins, so a timeout would have nothing to end.
export function useToTeachImportNotification(): void {
  const queryClient = useQueryClient();
  const { t } = useI18n();

  const handleUpdate = (
    data: ActionCableJobStatusData,
    _payload: unknown
  ): void => {
    if (data.action !== JobStatusActionEnum.to_teach_worksheet_import) return;
    if (data.status !== "completed") return;

    flash(FlashKindEnum.SUCCESS, t("materials.toTeachImport.importReady"));

    queryClient
      .getQueryCache()
      .findAll({ queryKey: getListItemNodesQueryKey() })
      .forEach(({ queryKey }) => {
        void queryClient.invalidateQueries({ queryKey });
      });
  };

  useJobStatusChannel({ onUpdate: handleUpdate });
}
